import "../common/ControlBtn/index.css";
import "./index.css";

import { ReactComponent as PrintBtnSvg } from "./printBtn.svg";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export default function PrintBtn(props: Props) {
  return (
    <button
      type="button"
      {...props}
      className={[
        "bordered atomic atoms simple-part print-btn bg-white control-btn",
        props.className
      ].join(" ")}
    >
      <PrintBtnSvg />
    </button>
  );
}
